import styled from 'styled-components';

export const Container = styled.div`
  max-width: 100%;
  min-width: 15rem;
`;

export const Subtitle = styled.h5`
  text-align: center;
  color: ${({ theme }) => theme.colors?.text.primary};
`;

interface Props {
  justify?: 'center' | 'start';
}
export const SubtitleH6 = styled.h6<Props>`
  text-align: ${(props) => props.justify};
  color: ${({ theme }) => theme.colors?.text.secondary};
`;

export const ButtonCheckbox = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors?.text.info02};

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    flex-direction: column;
    gap: 1rem;
  }
`;
